// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ADD_ENQUIRY } from '../../../../../common/constant'
import { get, post } from '../../../../../common/api'

export const actionAddEnquiry = createAsyncThunk('enquiryStore/actionAddEnquiry', async (params, thunkAPI) => {
    return await post(ADD_ENQUIRY, params, thunkAPI)
})


export const enquirySlice = createSlice({
    name: 'enquiryStore',

    initialState: {
        enquiryAdd: null,
        loadingEnquiryAdd: false,
    },
    reducers: {
        //reset or delete public store data
        resetEnquiryAddResponse: (state) => {
            state.enquiryAdd = null
        }
    },
    extraReducers: builder => {
        builder
            //enquiry add
            .addCase(actionAddEnquiry.pending, (state) => {
                state.loadingEnquiryAdd = true
            })
            .addCase(actionAddEnquiry.fulfilled, (state, action) => {
                state.loadingEnquiryAdd = false
                state.enquiryAdd = action.payload
            })
            .addCase(actionAddEnquiry.rejected, (state) => {
                state.loadingEnquiryAdd = false
            })
    }
})
export const { resetEnquiryAddResponse } = enquirySlice.actions

export default enquirySlice.reducer